import "../styles/Spinner.css";

const Spinner = () => {
  return (
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  );
};

export default Spinner;
